/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 * added logic to only load Zone after Adrum is loaded because of Promise issue with zone loading before Adrum
 */
export function getEnvironmentFromUrl(url: string) { // new pure helper for tests and reuse
  switch (true) {
    case url.indexOf('.dev.') > -1:
      return 'DEV';
    case url.indexOf('localhost') > -1:
      return 'Localhost';
    case url.indexOf('.test.') > -1:
      return 'TEST';
    case url.indexOf('xat-') > -1:
      return 'QA';
    default:
      return 'PROD';
  }
}
export function getEnvironment() { // changed to export for tests
  return getEnvironmentFromUrl(window.location.href);
}
const env = getEnvironment();
declare const require: any; // replaced var with const

if (env === "Localhost" || env === "TEST" || env === "DEV") {
  loadZone();
}
else {
  try {

    window["adrum-use-strict-domain-cookies"] = true;
    window["adrum-start-time"] = new Date().getTime();
    (function (config) {
      config = {
        ...config,
        adrumExtUrlHttp: "http://cdn.appdynamics.com",
        adrumExtUrlHttps: "https://cdn.appdynamics.com",
        beaconUrlHttp: "http://pdx-col.eum-appdynamics.com",
        beaconUrlHttps: "https://pdx-col.eum-appdynamics.com",
        useHTTPSAlways: true,
        xd: { enable: true },
        resTiming: {
          bufSize: 200,
          clearResTimingOnBeaconSend: true,
        },
        maxUrlLength: 512,
        spa: { spa2: true },
        isZonePromise: true,
        angular: true,
      };
      if (env === "PROD") {
        config.appKey = "AD-AAB-ABX-UUA";
        window["adrum-app-key"] = "AD-AAB-ABX-UUA";
      }
      else {
        config.appKey = "AD-AAB-ABX-USH";
        window["adrum-app-key"] = "AD-AAB-ABX-USH";
      }
    })(window["adrum-config"] || (window["adrum-config"] = {}));

    const adrumScript = document.createElement("script");
    adrumScript.setAttribute(
      "src",
      "//cdn.appdynamics.com/adrum/adrum-latest.js",
    );
    adrumScript.setAttribute(
      "onerror",
      "window.ADRUM = '';",
    );
    document.head.appendChild(adrumScript);

    void (async () => {
      while (!window.hasOwnProperty("ADRUM")) {
        // define the condition as you like
        await new Promise((resolve) => setTimeout(resolve, 10));
      }
      loadZone();
    })();

    /***************************************************************************************************
     * APPLICATION IMPORTS
     */
  }
  catch (error) {
    console.error("Error loading Adrum:", error);
    loadZone();
  }
}

function loadZone() {
  require("zone.js");
}